import { jsx as _jsx } from "react/jsx-runtime";
// ###### 1 => Framework imports ############
// ###### 2 => React imports #############
import React, { memo } from "react";
import * as Ant from "antd";
export const ToolTippedButton = memo(({ title, children, ...btnProps }) => {
    return (_jsx(Ant.Tooltip, { title: title, children: _jsx(Ant.Button, { ...btnProps, children: children }) }));
});
